import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiExperiencePromptActionPluginKey = new PluginKey('aiExperiencePromptAction');
